import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get, isNil} from 'lodash'
import {api} from 'services/api'
import {AsyncSelectField} from 'components/selectField'

class CompanySelectField extends Component {
  focus = () => {
    this.select.focus()
  }

  getOptions = (companies) => {
    const {isOptionDisabled} = this.props
    return companies.map(company => {
      const option = {
        value: company.id,
        label: company.name,
        company,
      }

      const disabled = !isNil(isOptionDisabled)
        ? isOptionDisabled(option)
        : false

      return {
        ...option,
        disabled,
      }
    })
  }

  render() {
    const {fields, params, userSettings, ...otherProps} = this.props

    const props = {
      ref: e => {
        this.select = e
      },
      placeholder: "Find a Company",
      params: {
        excludeHome: get(userSettings, 'excludeHomeCompanyFromReporting', false),
        sortColumn: 'name',
        sortDirection: 'asc',
        ...params,
      },
      fields: {
        name: true,
        ...fields,
      },
      onLoad: api.company.get,
      onOptions: this.getOptions,
      ...otherProps,
    }

    return <AsyncSelectField {...props} />
  }
}

CompanySelectField.propTypes = {
  fields: propTypes.object,
  params: propTypes.object,
  isOptionDisabled: propTypes.func,
  userSettings: propTypes.object,
  OptionRenderer: propTypes.func,
}

export default CompanySelectField
